import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Button, Flex, Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react';
import { PageName } from '@whitbread-eos/api';
import { formatDataTestId } from '@whitbread-eos/utils';
import { useEffect, useState } from 'react';
import { headerResultsTextStyle, headerResultsTextRedesignStyle, headerTableStyle, loadMoreStyles, resultContainerStyle, tableStyle } from './';
import TableListRowComponent from './TableListRow.component';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function TableList(_ref) {
  var _ref$dataTestIdPrefix = _ref.dataTestIdPrefix,
    dataTestIdPrefix = _ref$dataTestIdPrefix === void 0 ? '' : _ref$dataTestIdPrefix,
    columns = _ref.columns,
    rows = _ref.rows,
    _ref$isExpandable = _ref.isExpandable,
    isExpandable = _ref$isExpandable === void 0 ? true : _ref$isExpandable,
    _ref$expandBtnText = _ref.expandBtnText,
    expandBtnText = _ref$expandBtnText === void 0 ? 'View' : _ref$expandBtnText,
    _ref$collapseBtnText = _ref.collapseBtnText,
    collapseBtnText = _ref$collapseBtnText === void 0 ? 'Close' : _ref$collapseBtnText,
    renderExpandedContent = _ref.renderExpandedContent,
    _ref$loadMoreText = _ref.loadMoreText,
    loadMoreText = _ref$loadMoreText === void 0 ? '' : _ref$loadMoreText,
    onLoadMore = _ref.onLoadMore,
    _ref$isLoadingMore = _ref.isLoadingMore,
    isLoadingMore = _ref$isLoadingMore === void 0 ? false : _ref$isLoadingMore,
    screenSize = _ref.screenSize,
    containerStyles = _ref.containerStyles,
    externalHeaderStyles = _ref.externalHeaderStyles,
    rowStyles = _ref.rowStyles,
    handleRowClicked = _ref.handleRowClicked,
    rowHoverStyles = _ref.rowHoverStyles,
    _ref$isFixedLayout = _ref.isFixedLayout,
    isFixedLayout = _ref$isFixedLayout === void 0 ? true : _ref$isFixedLayout,
    pageName = _ref.pageName,
    isBookingHistoryRedesignPIAndBBEnabled = _ref.isBookingHistoryRedesignPIAndBBEnabled;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    expandedRowIndex = _useState2[0],
    setExpandedRowIndex = _useState2[1];
  var isBookingHistoryRedesign = isBookingHistoryRedesignPIAndBBEnabled && pageName === PageName.DASHBOARD;
  var fixedLayout = isBookingHistoryRedesign ? false : isFixedLayout;
  var tableStyling = tableStyle(fixedLayout);
  useEffect(() => {
    rows.length === 1 ? setExpandedRowIndex(0) : setExpandedRowIndex(null);
  }, [rows.length]);
  var handleExpand = (index, shouldCollapse) => {
    if (!renderExpandedContent) {
      return;
    }
    setExpandedRowIndex(shouldCollapse ? null : index);
  };
  var tableResultsHeadingStyle = isBookingHistoryRedesign ? headerResultsTextRedesignStyle : headerResultsTextStyle;
  return _jsxs(TableContainer, _objectSpread(_objectSpread(_objectSpread({
    "data-testid": formatDataTestId(dataTestIdPrefix, 'Table-Container')
  }, resultContainerStyle), containerStyles), {}, {
    children: [_jsxs(Table, {
      size: "sm",
      style: tableStyling,
      children: [_jsx(Thead, _objectSpread(_objectSpread({}, headerTableStyle), {}, {
        children: _jsxs(Tr, {
          children: [columns.map(column => {
            return screenSize !== null && screenSize !== void 0 && screenSize.isLessThanSm && column !== null && column !== void 0 && column.hideOnMobile ? null : _jsx(Th, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, tableResultsHeadingStyle), externalHeaderStyles)), {}, {
              "data-testid": formatDataTestId(dataTestIdPrefix, "TableHeader-".concat(column.key)),
              children: column.title
            }), column.key);
          }), isExpandable && !isBookingHistoryRedesign && _jsx(Th, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, tableResultsHeadingStyle), externalHeaderStyles)), {}, {
            "data-testid": formatDataTestId(dataTestIdPrefix, "TableHeader-expand")
          }), 'expand')]
        })
      })), _jsx(Tbody, {
        children: rows.map((row, rowIndex) => {
          return _jsx(TableListRowComponent, {
            row: row,
            rowIndex: rowIndex,
            columns: columns,
            dataTestIdPrefix: dataTestIdPrefix,
            isExpandable: isExpandable,
            expandBtnText: expandBtnText,
            collapseBtnText: collapseBtnText,
            screenSize: screenSize,
            isExpanded: expandedRowIndex === rowIndex,
            onExpand: handleExpand,
            renderExpandedContent: renderExpandedContent,
            rowStyles: rowStyles,
            rowHoverStyles: rowHoverStyles,
            handleRowClicked: handleRowClicked,
            isBookingHistoryRedesign: isBookingHistoryRedesign
          }, row.bookingReference);
        })
      })]
    }), onLoadMore && loadMoreText && _jsx(Flex, {
      direction: "column",
      justify: "center",
      children: _jsx(Button, _objectSpread(_objectSpread({
        variant: "tertiary",
        size: "sm",
        onClick: onLoadMore,
        "data-testid": formatDataTestId(dataTestIdPrefix, 'Table-LoadMore'),
        isLoading: isLoadingMore
      }, loadMoreStyles), {}, {
        children: loadMoreText
      }))
    })]
  }));
}